module.exports = __webpack_public_path__ + "static/Personalisation@2x-7a718678964aa29c9aceb3d30a80d8de.png";